import Key from "../../../src/clientVariables.json";

export const openAI = async (message, callback) => {
  const endpoint = "/ai-search/gpt-parse";
  const url = `${Key.domain.replace(/\/+$/,'')}${endpoint}`;

  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-api-key": Key.apiKey,
      },
      body: JSON.stringify({ message, useCache: true }),
    });

    // Try to parse JSON either way
    let body = null;
    try {
      body = await resp.json();
    } catch {
      body = null; // Non-JSON response
    }

    if (!resp.ok) {
      // Server-side error path (e.g., 4xx/5xx)
      const err = body && (body.error || body.message)
        ? body
        : { error: "Request failed", message: `HTTP ${resp.status}` };
      return callback(err);
    }

    // Success path: body should look like { success: true, data, cached?, deduped? }
    if (body && body.success) {
      return callback(null, body.data);
    }

    // Unexpected shape but OK status
    return callback(null, { message: body?.message ?? "No data" });
  } catch (networkErr) {
    // Network/timeout/cors/etc
    return callback({ error: "Network error", message: String(networkErr) });
  }
};
